import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from 'src/configContext.ts';

export function usePageChange(target: (page: number) => string, callback: (page: number) => void) {
    const { rootElement } = useContext(ConfigContext);
    const navigate = useNavigate();
    return useCallback((newPage: number, newSearchParams: URLSearchParams) => {
        rootElement.ownerDocument?.scrollingElement?.scrollTo({ top: 0 });
        callback(newPage);
        navigate({
            pathname: target(newPage),
            search: newSearchParams.toString(),
        });
    }, [rootElement, navigate, callback, target]);
}
